/**
 * Join truthy class-name parts into a single space-separated string — the className
 * idiom shared across the token-CSS Punchup tier (replaces inline
 * `[...].filter(Boolean).join(" ")`). Pure; no Tailwind-merge semantics (the tier
 * does not use Tailwind), so later duplicate classes are kept as-is.
 */
export const cx = (...parts: (string | undefined | false | null)[]): string =>
  parts.filter(Boolean).join(" ");
